import {
  EHeadingStyleVariant,
  ETextStyleVariant,
  GeneralCheckFilledIcon,
  Heading,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import MaxWidth from '@/components/common/layout/MaxWidth';

export const GroupRvHowItWorks: React.FC = () => {
  const intl = useIntl();

  const phases = [
    {
      phase: intl.formatMessage({
        id: 'G84sxS',
        defaultMessage: 'Phase one',
        description: 'Group bookings how it works phase 1 label',
      }),
      items: [
        {
          title: intl.formatMessage({
            id: '0R9w7t',
            defaultMessage: 'Submit the enquiry form',
            description: 'Group bookings how it works phase 1 submit enquiry title',
          }),
          description: intl.formatMessage({
            id: 'VMbRXO',
            defaultMessage:
              'Submit the enquiry form with all of the details for what your group needs. Our concierge team will review and get back to you within 24 hours.',
            description: 'Group bookings how it works phase 1 submit enquiry description',
          }),
        },
        {
          title: intl.formatMessage({
            id: 'ofZamM',
            defaultMessage: 'Dedicated point of contact',
            description: 'Group bookings how it works phase 1 dedicated contact title',
          }),
          description: intl.formatMessage({
            id: 'JD8miv',
            defaultMessage:
              'Your concierge specialist will be the dedicated point of contact between your group and your RV host(s).',
            description: 'Group bookings how it works phase 1 dedicated contact description',
          }),
        },
      ],
    },
    {
      phase: intl.formatMessage({
        id: 'l/jOtS',
        defaultMessage: 'Phase two',
        description: 'Group bookings how it works phase 2 label',
      }),
      items: [
        {
          title: intl.formatMessage({
            id: 'xEMYVo',
            defaultMessage: 'Booking consultation',
            description: 'Group bookings how it works phase 2 booking consultation title',
          }),
          description: intl.formatMessage({
            id: 'N0PaZN',
            defaultMessage:
              'Our Concierge Team will discuss the details of your event with you and work with your budget to find the right RVs for you and your group.',
            description: 'Group bookings how it works phase 2 booking consultation description',
          }),
        },
        {
          title: intl.formatMessage({
            id: 'KSu3Pg',
            defaultMessage: 'Level of support',
            description: 'Group bookings how it works phase 2 level of support title',
          }),
          description: intl.formatMessage({
            id: 'a6w/VK',
            defaultMessage:
              'Support and resources for bookings of 5+ vehicles, and white glove service to handle everything for bookings of 10+ vehicles.',
            description: 'Group bookings how it works phase 2 level of support description',
          }),
        },
      ],
    },
    {
      phase: intl.formatMessage({
        id: '30AX1x',
        defaultMessage: 'Phase three',
        description: 'Group bookings how it works phase 3 label',
      }),
      items: [
        {
          title: intl.formatMessage({
            id: '5Ad5sq',
            defaultMessage: 'Host coordination',
            description: 'Group bookings how it works phase 3 host coordination title',
          }),
          description: intl.formatMessage({
            id: 'udUr02',
            defaultMessage:
              'Your concierge specialist will coordinate all logistics with you and the host(s) of your rentals through your start date.',
            description: 'Group bookings how it works phase 3 host coordination description',
          }),
        },
        {
          title: intl.formatMessage({
            id: 'Dg9JC/',
            defaultMessage: 'Booking management',
            description: 'Group bookings how it works phase 3 booking management title',
          }),
          description: intl.formatMessage({
            id: 'seGSRi',
            defaultMessage:
              'They will also help with account set-up, insurance, payment, and provide guidance on rental contracts and logistics.',
            description: 'Group bookings how it works phase 3 booking management description',
          }),
        },
      ],
    },
  ];

  return (
    <section className="py-12 border-t border-gray-200 bg-canvas-100 lg:py-16">
      <div className="flex justify-center lg:px-12">
        <MaxWidth className="gap-10">
          {/* Heading */}
          <div className="max-w-3xl mb-8 lg:mb-12">
            <Heading
              variant={EHeadingStyleVariant.H3}
              className="mb-3 leading-tight text-gray-900 font-[abril-titling]">
              <FormattedMessage
                id="jh2pTd"
                defaultMessage="How it works."
                description="Group bookings how it works section heading"
              />
            </Heading>

            <Text variant={ETextStyleVariant.MediumRegular} className="mb-1 text-gray-70">
              <FormattedMessage
                id="PpWP58"
                defaultMessage="When you need 5+ RVs and the help of an expert booking concierge, we’ve got you covered."
                description="Group bookings how it works section intro line 1"
              />
            </Text>

            <Text variant={ETextStyleVariant.MediumRegular} className="text-gray-70">
              <FormattedMessage
                id="NHd5og"
                defaultMessage="Submit your booking enquiry and we’ll help you through the entire process."
                description="Group bookings how it works section intro line 2"
              />
            </Text>
          </div>

          {/* Phases */}
          <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
            {phases.map(({ phase, items }) => (
              <div key={phase}>
                <Text
                  variant={ETextStyleVariant.SmallBold}
                  className="mb-4 uppercase tracking-[0.18em] text-gray-70">
                  {phase}
                </Text>

                {items.map(({ title, description }, index) => (
                  <div key={title} className={`flex gap-3 ${index === 0 ? 'mb-5' : ''}`}>
                    <GeneralCheckFilledIcon
                      className="mt-1 text-green-500 shrink-0"
                      fontSize={20}
                    />

                    <div>
                      <Text variant={ETextStyleVariant.MediumBold} className="text-gray-900">
                        {title}
                      </Text>
                      <Text variant={ETextStyleVariant.MediumRegular} className="text-gray-70">
                        {description}
                      </Text>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </MaxWidth>
      </div>
    </section>
  );
};
